// Service page content for Skilled Work Regional Provisional (Subclass 491).
// Sourced from docs/research/australian-visa-pathways.md §1.
// COMPLIANCE: we are not a registered migration agent and do not give migration
// advice or assess eligibility; the regulated advice and lodgement are a
// registered migration agent's. Honest about the provisional nature and the
// regional/income conditions that gate the 191 PR transition; no guarantees.
// "Who does what" disclosure and disclaimer are rendered by the shared template.

const skilledRegional491 = {
  groupSlug: "skilled-migration",
  slug: "skilled-regional-491",
  title: "Skilled Work Regional visa (Subclass 491)",
  eyebrow: "Skilled Migration",
  intro:
    "The Subclass 491 is a points-tested provisional visa for skilled workers willing to live and work in regional Australia. Nomination by a state or sponsorship by an eligible relative adds 15 points, the largest boost of any skilled visa. It runs for 5 years and is the pathway to permanent residence through the Subclass 191.",

  chips: [
    { label: "Visa type", value: "Provisional, 5 years" },
    { label: "Nomination", value: "State or relative (+15 points)" },
    { label: "Location", value: "Designated regional area" },
    { label: "Leads to", value: "Permanent residence (191)" },
  ],

  whoFor: [
    "Skilled workers open to living, working, and studying in a designated regional area.",
    "Applicants who need the 15-point boost to be competitive.",
    "People comfortable with a provisional visa first, then a permanent 191 once the conditions are met.",
  ],

  essentials: [
    {
      title: "Regional nomination or family sponsorship",
      detail:
        "You need a state or territory nomination, or sponsorship by an eligible relative living in a designated regional area. This adds 15 points.",
    },
    {
      title: "A positive skills assessment",
      detail:
        "Your nominated occupation must be assessed by the relevant assessing authority and be eligible for the 491.",
    },
    {
      title: "An invitation through SkillSelect",
      detail:
        "You submit an Expression of Interest and are invited to apply. You cannot apply directly.",
    },
    {
      title: "Under 45 and at least competent English",
      detail: "The standard skilled-visa age and English thresholds apply.",
    },
    {
      title: "Commitment to a designated regional area",
      detail:
        "You must live, work, and study only in a designated regional area, which is everywhere except Sydney, Melbourne, and Brisbane.",
    },
    {
      title: "An eye on the 191 from day one",
      detail:
        "The 491 is a stepping stone. Meeting the regional-residence and income conditions is what unlocks permanent residence later.",
    },
  ],

  process: [
    {
      title: "Skills assessment",
      detail:
        "A registered migration agent confirms your occupation, and we organise and prepare the evidence to obtain a positive assessment from the right assessing authority.",
    },
    {
      title: "Find your regional sponsor or nominator",
      detail:
        "A registered migration agent identifies which states nominate your occupation, or whether an eligible relative can sponsor you. We gather the supporting documents.",
    },
    {
      title: "Prepare your EOI and nomination",
      detail:
        "We build your SkillSelect EOI and nomination or sponsorship file to a lodgement standard. A registered migration agent finalises the points claim and lodges.",
    },
    {
      title: "Receive your invitation",
      detail:
        "If nominated or sponsored, you are invited to apply within the time allowed.",
    },
    {
      title: "Lodge the visa application",
      detail:
        "We prepare a thorough file. A registered migration agent lodges the application and deals with the Department.",
    },
    {
      title: "Plan the 191 transition",
      detail:
        "Once granted, we help you organise and track the regional-residence and income records you will need for permanent residence.",
    },
  ],

  faqs: [
    {
      q: "Where can I live on a 491?",
      a: "Anywhere in Australia classed as a designated regional area, which currently means everywhere except Sydney, Melbourne, and Brisbane. You must live, work, and study within those areas while you hold the visa.",
    },
    {
      q: "How do I get permanent residence from a 491?",
      a: "Through the Subclass 191. You generally need to have lived in a designated regional area and met a minimum taxable income requirement for at least three years while holding the 491, with tax returns as evidence. We help you organise and keep the records so you stay on track for it.",
    },
    {
      q: "Why is the 491 worth 15 points?",
      a: "Because the government uses it to direct skilled migration to regional areas. The 15-point boost is the largest of any skilled visa and can make an invitation realistic when the 189 or 190 would not. The trade-off is the regional commitment.",
    },
    {
      q: "What happens if I cannot meet the regional or income conditions?",
      a: "Honestly, it can block your move to permanent residence on the 191. This is the most important risk to understand before choosing the 491, and a registered migration agent walks you through it so there are no surprises later.",
    },
  ],

  related: [
    "permanent-regional-191",
    "skilled-nominated-190",
    "skilled-independent-189",
  ],

  lastVerified: "13 July 2026",
};

export default skilledRegional491;
